module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['Maps']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module Maps URL not available') },
        init: (arg) => { throw new Error('Module Maps URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['Maps'].get(request),
      init: (arg) => {
        try {
          return window['Maps'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: Maps')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module Maps not available') },
      init: (arg) => { throw new Error('Module Maps not available') }
    })
    document.head.appendChild(script);
  });